import React, { Suspense, lazy } from 'react';
import tenantConstants from '@constants';
import Cookies from 'js-cookie';

// Loaded only when the cookie is set, so the Overview page never pulls in any Listings V2 code.
const RecentListingsV2 = lazy(() => import('./MyListings/RecentListings'));

/**
 * The Overview page's Recent Listings widget, behind the same switch as the listings page itself:
 * with `tenantConstants.LISTINGS_V2_COOKIE` set the Overview list is drawn in the Listings V2
 * design, and without it the page keeps the legacy table it renders as `children`.
 *
 * One cookie for both surfaces on purpose -- a user who has the new My Listings should not land on
 * the Overview page and find the old one.
 */
const RecentListingsGate = ({ children, ...props }) => {
  if (!Cookies.get(tenantConstants.LISTINGS_V2_COOKIE)) return children;
  return (
    <Suspense fallback={null}>
      <RecentListingsV2 {...props} />
    </Suspense>
  );
};

export default RecentListingsGate;
